import { forwardRef } from 'react';
import InputInternal from './input-internal';
import Enhancer from './enhancer';
var Input = forwardRef(InputInternal);
var InputNamespace = Object.assign(Input, {
    Enhancer: Enhancer,
});
export default InputNamespace;
